var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2915 0.0559692C8.43533 0.0559692 0.416504 8.25704 0.416504 18.3372C0.416504 28.4174 8.43533 36.6185 18.2915 36.6185C28.1477 36.6185 36.1665 28.4174 36.1665 18.3372C36.1665 8.25704 28.1477 0.0559692 18.2915 0.0559692ZM25.1665 19.7435H19.6665V25.3685C19.6665 25.7414 19.5216 26.0991 19.2638 26.3628C19.0059 26.6266 18.6562 26.7747 18.2915 26.7747C17.9268 26.7747 17.5771 26.6266 17.3192 26.3628C17.0614 26.0991 16.9165 25.7414 16.9165 25.3685V19.7435H11.4165C11.0518 19.7435 10.7021 19.5953 10.4442 19.3316C10.1864 19.0679 10.0415 18.7102 10.0415 18.3372C10.0415 17.9643 10.1864 17.6066 10.4442 17.3428C10.7021 17.0791 11.0518 16.931 11.4165 16.931H16.9165V11.306C16.9165 10.933 17.0614 10.5753 17.3192 10.3116C17.5771 10.0479 17.9268 9.89972 18.2915 9.89972C18.6562 9.89972 19.0059 10.0479 19.2638 10.3116C19.5216 10.5753 19.6665 10.933 19.6665 11.306V16.931H25.1665C25.5312 16.931 25.8809 17.0791 26.1388 17.3428C26.3966 17.6066 26.5415 17.9643 26.5415 18.3372C26.5415 18.7102 26.3966 19.0679 26.1388 19.3316C25.8809 19.5953 25.5312 19.7435 25.1665 19.7435Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.321ebc7f1e7c51f46e71a556a8397b52.svg";
export { ForwardRef as ReactComponent };